import Flatpickr from "stimulus-flatpickr"

// Connects to data-controller="date-pair"
// Used on one half (start or end) of an independent start/end date pair.
// Keeps a hidden "date_range" field in sync for controllers that expect a
// combined "start to end" string, then submits the form.
export default class extends Flatpickr {
  change(selectedDates, dateStr, instance) {
    if (selectedDates.length !== 1) return;

    const form = this.element.closest("form");
    const start = form.querySelector('input[name="start_date"]')?.value;
    const end = form.querySelector('input[name="end_date"]')?.value;
    if (!start || !end) return;

    const combined = form.querySelector('input[name="date_range"]');
    if (combined) combined.value = `${start} to ${end}`;

    form.submit();
  }
}
